import React from 'react'
import {
  ListProps,
  Pagination,
  Filter,
  TextField,
  TextInput,
  Datagrid,
  ReferenceField,
  FunctionField,
  useTranslate,
} from 'react-admin'
import { ResourceName } from '../../../../core/ResourceName'
import List from '../../../common/customized-ra-components/List'
import FilterProps from '../../../common/FilterProps'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { EngineMediaActionDto } from '../../../../core/dto/engine-media/engine-media-action.dto'
import { EngineMediaFileDto } from '../../../../core/dto/engine-media/engine-media-file.dto'

const EngineMediaFileFilters = (props: FilterProps) => (
  <Filter {...props}>
    <TextInput source="description" alwaysOn />
  </Filter>
)

export const EngineMediaFileList = (props: ListProps) => {
  const hasAuthority = useHasAuthority()
  const translate = useTranslate()

  return (
    <List
      {...props}
      exporter={false}
      filters={<EngineMediaFileFilters />}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[10, 20, 50, 100, 200]} />}
      bulkActionButtons={false}
    >
      <Datagrid
        size="small"
        rowClick={(id) => `${ResourceName.ENGINE_MEDIA_FILES}/${id}/show`}
      >
        <TextField source="id" label="ID" />
        <TextField source="description" />
        {hasAuthority(Authority.VIEW_ENGINE_MEDIA_ACTIONS) && (
          <ReferenceField
            source="engineMediaActionId"
            reference={ResourceName.ENGINE_MEDIA_ACTIONS}
            link={hasAuthority(Authority.EDIT_ENGINE_MEDIA_ACTIONS) && 'edit'}
          >
            <FunctionField<EngineMediaActionDto>
              render={(record?: EngineMediaActionDto) =>
                `${record?.id}. ${record?.name} (${record?.mediaAction})`
              }
            />
          </ReferenceField>
        )}
        <FunctionField<EngineMediaFileDto>
          source="mediaContentType"
          render={(record?: EngineMediaFileDto) =>
            translate(
              `resources.enums.MediaContentTypes.${record?.mediaContentType}`,
            )
          }
        />
      </Datagrid>
    </List>
  )
}
